module.exports = __webpack_public_path__ + "static/media/atrbpn.81919c1e.png";